<aside class="sidenav-container flex-shrink-0 d-flex flex-column">
  <a
    routerLink="/"
    class="sidenav-header d-flex align-items-center justify-content-center gap-1 text-decoration-none"
  >
    <img
      src="assets/icons/avyna/logo.svg"
      [alt]="'backoffice.shell.logo_alt' | translate"
      class="logo"
    />
  </a>

  <div class="routes-container d-flex flex-column">
    <div class="nav-section pe-2 ps-2 pb-2 pt-3">
      <p class="section-label ps-3">{{ 'backoffice.shell.nav.section' | translate }}</p>

      <div class="nav-buttons d-flex flex-column">
        @for (item of navItems(); track item.route) {
          <a
            [routerLink]="item.route"
            class="nav-btn d-flex align-items-center text-decoration-none px-2 py-1 rounded"
            [class.active]="activeRoute() === item.route"
          >
            <mat-icon>{{ item.icon }}</mat-icon>
            <span>{{ item.label | translate }}</span>
          </a>
        }
      </div>
    </div>

    <div class="sidenav-footer d-flex justify-content-center align-items-center mb-2 mx-2">
      <av-theme-toggle></av-theme-toggle>
    </div>
  </div>
</aside>
